import { CheckboxField, MultipleSelectField } from "components/RenderInput"
import UnsavedAlertModal from "components/UnsavedAlertModal"
import { FORM_NAMES } from "constants/index"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { Field, formValueSelector, isDirty, reset } from "redux-form"
import { getMetaTags } from "store/actions"

const AccessTab = ({
  metaTags,
  accessByTags,
  handleSave,
  tabIsActive,
  resetForm,
  isDirty,
  getMetaTags,
}) => {
  const [showAlertModal, setShowAlertModal] = useState(false)

  useEffect(() => {
    getMetaTags({})
  }, [])

  useEffect(() => {
    if (!tabIsActive && isDirty) {
      setShowAlertModal(true)
    }
  }, [tabIsActive])

  return (
    <React.Fragment>
      <Card>
        <CardHeader>
          <h4>SET ACCESS</h4>
        </CardHeader>
        <CardBody>
          <Row>
            <Col xs="auto">
              <label>Limit Access:</label>
            </Col>
            <Col>
              <Field
                component={CheckboxField}
                name="accessByTags"
                label="Give Access to Book By Tags"
              />
            </Col>
          </Row>
          {accessByTags && (
            <Row className="my-3">
              <Col xl={3}>
                <Field
                  name="tags"
                  placeholder="Enter tag"
                  component={MultipleSelectField}
                  options={metaTags.map(tag => ({
                    label: tag.tag,
                    value: tag.id,
                  }))}
                />
              </Col>
            </Row>
          )}
        </CardBody>
      </Card>
      <UnsavedAlertModal
        isOpen={showAlertModal}
        onClose={() => {
          setShowAlertModal(false)
          resetForm()
        }}
        onSave={() => {
          handleSave()
          setShowAlertModal(false)
        }}
      />
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.SUB_CALENDARS)

const mapStateToProps = state => ({
  metaTags: state.Tags.metaTags,
  accessByTags: selector(state, "access.accessByTags"),
  isDirty: isDirty(FORM_NAMES.SUB_CALENDARS)(state, ...["access"]),
})

const mapDispatchToProps = dispatch => ({
  resetForm: () => dispatch(reset(FORM_NAMES.SUB_CALENDARS)),
  getMetaTags: values => dispatch(getMetaTags(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(AccessTab)
